// 모바일 viewport height 처리 플러그인 (클라이언트 전용)
export default defineNuxtPlugin(() => {
  if (process.client) {
    let resizeTimer: NodeJS.Timeout | null = null

    const setViewportHeight = (): void => {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      //console.log('100vh size updated:', `${vh}px`)
    }

    const handleResize = (): void => {
      if (resizeTimer) {
        clearTimeout(resizeTimer)
      }
      resizeTimer = setTimeout(() => {
        setViewportHeight()
      }, 250)
    }

    // 초기 설정
    setViewportHeight()

    // 리사이즈 이벤트 리스너 등록
    window.addEventListener('resize', handleResize)
  }
})
